import {
  Box,
  Flex,
  List,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { useMediaQuery } from '@chakra-ui/media-query';
import { useQuery } from '@apollo/client';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import TeamCard from '../components/TeamCard';
import Link from 'next/link';
import { generatePath } from '../lib/generatePath';
import { GET_TEAMS } from '../apollo/queries/GetTeams';

const About = ({ global }) => {
  const [isLargerThan1024] = useMediaQuery('(min-width: 1024px)');

  const { data, loading, error, networkStatus } = useQuery(GET_TEAMS, {
    context: { clientName: 'strapi' },
    fetchPolicy: 'cache-first',
  });

  let TEAM = [];
  // Order team members based on their position
  if (!loading) {
    let newData = data.teams.data.map((item) => item.attributes);

    TEAM = newData.sort((a, b) => {
      return a.position - b.position;
    });
  }

  return (
    <Layout global={global}>
      <Seo seo={{}} />
      <Flex
        direction="column"
        maxW={720}
        margin={isLargerThan1024 ? '4rem auto' : '4rem 2rem'}
      >
        <Text
          fontSize="1.6rem"
          fontWeight="700"
          color="#006067"
          textAlign="center"
          my={10}
        >
          Then and Now
        </Text>
        <Text
          style={{ fontSize: '1.1rem', lineHeight: '1.7', textAlign: 'left' }}
        >
          The Anders Pink team has been in Learning technology for a long time.
          We&apos;ve designed and built digital learning courses, blended
          programmes, Learning Management Systems and grown successful
          businesses, including Kineo, now a leader in the global learning
          market.
          <br />
          <br />
          Over the years, Anders Pink has grown from offering a{' '}
          <Link style={{ color: '#cf0032' }} href="/wc/enterprise">
            Web Curation
          </Link>{' '}
          product - bringing the best of the web, tailored to your teams&apos;
          needs, updating every day, inside the tools and platforms you&apos;re
          already using - to offering a suite of products, to include Complete
          Curation and{' '}
          <Link style={{ color: '#cf0032' }} href="/content-skills-mapper">
            Content to Skills Mapper
          </Link>
          .
          <br />
          <br />
          Anders Pink&apos;s suite of products helps organizations to discover
          and curate the world&apos;s best learning content, automatically
          mapped to the skills that matter. So your teams can stay up to date
          and you get a better return on your learning content investment.
          <br />
          <br />
          At the end of 2022, Anders Pink was acquired by Go1, offering the
          largest curated learning content library in the world, aggregating
          courses from hundreds of providers to make it easy for learners to
          access the best courses and content for them. We have a shared purpose
          in the value of curated content and intelligent recommendations to
          create the best learning experience.
          <br />
          <br />
          Together, Go1 and Anders Pink want to bring the best learning content,
          aligned to the skills and interests that matter, to the world&apos;s
          learners.
        </Text>
        <Text
          fontSize="1.6rem"
          fontWeight="700"
          color="#006067"
          textAlign="center"
          my={10}
        >
          The challenges we solve
        </Text>
        <Text
          style={{ fontSize: '1.1rem', lineHeight: '1.7', textAlign: 'left' }}
        >
          We all need to continuously learn and develop. L&D teams are tasked
          with finding the right content aligned to key skills, and organize
          them in learning platforms as playlists or pathways. But it&apos;s not
          easy.
        </Text>
        <UnorderedList
          pt={10}
          pb={10}
          style={{ fontSize: '1.1rem', lineHeight: '1.7', textAlign: 'left' }}
        >
          <ListItem>
            There&apos;s a lot of content - in your organization, in licensed
            third-party libraries and on the web, and it isn&apos;t easy to
            search and structure it
          </ListItem>
          <br />
          <ListItem>
            It&apos;s time consuming to determine the value and relevance of
            thousands of content assets
          </ListItem>
          <br />
          <ListItem>
            Mapping content against skills is a complex, manual task
          </ListItem>
          <br />
          <ListItem>
            Integrating content with learning platforms takes time
          </ListItem>
          <br />
          <ListItem>
            It&apos;s a daily challenge to keep learners up to date on the
            latest insights
          </ListItem>
          <br />
          <ListItem>
            It&apos;s difficult keeping learners engaged and coming back to the
            learning platforms that have been invested in
          </ListItem>
        </UnorderedList>
        <Text
          style={{ fontSize: '1.1rem', lineHeight: '1.7', textAlign: 'left' }}
        >
          We want to make it easier. That&apos;s why we&apos;ve built the Anders
          Pink Product Suite.
          <br />
          <br />
          And for Learning platform providers? Anders Pink partners can power up
          their Learning Platform by bringing our product suite directly into
          their learning platform via API or by making it part of their learning
          ecosystem, giving them enhanced search, tagging and recommendation
          capabilities.
        </Text>
      </Flex>
      {/* <Box maxW={820} margin={isLargerThan1024 ? '0 auto' : '4rem 2rem'}>
        <Text
          fontSize="1.6rem"
          fontWeight="700"
          color="#006067"
          textAlign="center"
          my={10}
        >
          Meet your core team
        </Text>
        <Flex
          direction={isLargerThan1024 ? 'row' : 'column'}
          justifyContent="space-between"
        >
          {TEAM && TEAM.map((item, id) => <TeamCard key={id} item={item} />)}
        </Flex>
        <Box width={820} />
      </Box> */}
      {/* <Flex
        direction="column"
        maxW={720}
        margin={isLargerThan1024 ? '4rem auto' : '4rem 2rem'}
      >
        <Text
          style={{ fontSize: '1.1rem', lineHeight: '1.7', textAlign: 'left' }}
        >
          We&apos;d love to help you with a new way to stay smart every day.{' '}
          <Link
            href={generatePath('/contact')}
            style={{
              fontSize: 18,
              fontWeight: '300',
              color: '#cf0032',
              textDecoration: 'none',
            }}
          >
            Get in touch
          </Link>{' '}
          and let&apos;s make it happen.
        </Text>
      </Flex> */}

      <Flex
        direction="column"
        maxW={720}
        margin={isLargerThan1024 ? '4rem auto' : '4rem 2rem'}
        alignItems={'center'}
      >
        <Text
          style={{ fontSize: '1.1rem', lineHeight: '1.7', textAlign: 'left' }}
        >
          To find out more about our Suite of Products{' '}
        </Text>
        <Link
          href={generatePath('/contact')}
          style={{
            fontSize: 18,
            fontWeight: '300',
            color: '#cf0032',
            textDecoration: 'none',
          }}
        >
          Get in touch
        </Link>{' '}
      </Flex>
    </Layout>
  );
};

export default About;
